import { API, standardResponse } from "./middleware";

export async function save(formData) {
  const url = "/api/config-website/save";
  return API.post(url, formData, {
    headers: {
      "Content-Type": "multipart/form-data", // Quan trọng khi gửi FormData
    },
  })
    .then((response) => response.data)
    .catch((error) => standardResponse(false, error.response?.data));
}

export async function getWebsite() {
  const url = "/api/public/getWebsite";
  return API.get(url)
    .then((response) => response.data)
    .catch((error) => standardResponse(false, error.response?.data));
}
